/** The highest z-index supported consistently by browsers. */
export const DROPDOWN_OVERLAY_Z_INDEX = 2_147_483_647;

/** Dialogs sit below portalled dropdown menus. */
export const MODAL_OVERLAY_Z_INDEX = DROPDOWN_OVERLAY_Z_INDEX - 1;

/**
 * Full-screen forms and slide-over panels sit below confirmation modals.
 * Keeping this within the browser's portable range prevents values being
 * clamped together and losing their intended ordering.
 */
export const OVERLAY_Z_INDEX = MODAL_OVERLAY_Z_INDEX - 1;

/** Backwards-compatible name for the form/report overlay consumers. */
export const FORM_OVERLAY_Z_INDEX = OVERLAY_Z_INDEX;
